<template>
  <div>
    <div class="form-group">
      <label>Domain Key</label>
      <input type="text" class="form-control" v-model="data.domainKey">
    </div>
    <div class="form-group">
      <label>Source ID</label>
      <input type="text" class="form-control" v-model="data.sourceId">
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: [
    'data'
  ],
  data() {
    return {
    };
  }
}
</script>